// britam-admin.ts
import { FormattedMessage } from 'react-intl';
import { IconDashboard, IconDeviceAnalytics, IconPencilPlus, IconFileCheck, IconFileX, IconSettings } from '@tabler/icons-react';
import { getUserRegionFromStorage } from 'Application/utils';


const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconPencilPlus,
    IconFileCheck,
    IconFileX,
    IconSettings
};

// Country-based menu item configuration
const countryMenuItems = {
    Kenya: {
        id: 'generateQuoteKenya',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-admin/travel-portal/generate-quote',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    },
    Rwanda: {
        id: 'generateQuoteRwanda',
        title: <FormattedMessage id="Buy Now" />,
        type: 'item',
        url: '/britam-admin/travel-portal/generate-quote-rw',
        icon: icons.IconPencilPlus,
        breadcrumbs: false
    }
};
const userCountry = (getUserRegionFromStorage() ?? "Kenya") as keyof typeof countryMenuItems;
const selectedCountryItem = countryMenuItems[userCountry];


export const BritamAdminHomeItem = {
    id: 'britam-admin',
    title: <FormattedMessage id="Britam Admin" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id="Home" />,
            type: 'item',
            url: '/britam-admin/home',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const BritamAdminTravelInsurance = {
    id: 'travelInsurance',
    title: <FormattedMessage id="Travel Insurance" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        selectedCountryItem, // Dynamically select based on userCountry
        {
            id: 'Completed Transactions',
            title: <FormattedMessage id="Completed Transactions" />,
            type: 'item',
            url: '/britam-admin/travel-portal/completed-transactions',
            icon: icons.IconFileCheck,
            breadcrumbs: false
        },
        {
            id: 'Generated Quotes',
            title: <FormattedMessage id="Generated Quotes" />,
            type: 'item',
            url: '/britam-admin/travel-portal/generated-quotes',
            icon: icons.IconFileX,
            breadcrumbs: false
        }
    ]
};

export const BritamAdminUsers = {
    id: 'britam-admin-users',
    title: <FormattedMessage id="Users" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-admin-users-management',
            title: <FormattedMessage id="Users Management" />,
            icon: icons.IconDashboard,
            type: 'item',
            url: '/britam-admin/users/management',
            breadcrumbs: false
        }
    ]
};

export const BritamAdminProducts = {
    id: 'britam-admin-products',
    title: <FormattedMessage id="Products" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-admin-travel',
            title: <FormattedMessage id="Travel" />,
            icon: icons.IconDashboard,
            type: 'collapse',
            children: [
                {
                    id: 'britam-admin-travel-setup',
                    title: <FormattedMessage id="Setup" />,
                    type: 'item',
                    url: '/britam-admin/products/travel/setup',
                    breadcrumbs: false
                },
                {
                    id: 'britam-admin-travel-reports',
                    title: <FormattedMessage id="Reports" />,
                    type: 'item',
                    url: '/britam-admin/products/travel/reports',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export const BritamAdminAgencies = {
    id: 'britam-admin-agencies',
    title: <FormattedMessage id="Agencies" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'britam-admin-agencies-agencies',
            title: <FormattedMessage id="Agencies" />,
            type: 'item',
            url: '/britam-admin/agencies',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export const Adminsupport = {
    id: 'support',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        // {
        //     id: 'support',
        //     title: <FormattedMessage id="Support" />,
        //     type: 'item',
        //     url: '/britam-admin/support',
        //     icon: icons.IconHelpHexagon,
        //     breadcrumbs: false
        // },
        {
            id: 'Settings',
            title: <FormattedMessage id="Settings" />,
            type: 'item',
            url: '/britam-admin/settings',
            icon: icons.IconSettings,
            breadcrumbs: false
        }
    ]
};
